import type { ComponentType } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { BarChart3, Layers, Ticket } from 'lucide-react';

interface Tab {
  to: string;
  label: string;
  icon: ComponentType<{ className?: string }>;
  end?: boolean;
}

const tabs: Tab[] = [
  { to: '/platform-admin/billing', label: 'Overview', icon: BarChart3, end: true },
  { to: '/platform-admin/billing/plans', label: 'Plans', icon: Layers },
  { to: '/platform-admin/billing/coupons', label: 'Coupons', icon: Ticket },
];

/** Platform Super Admin console — gated by ProtectedRoute's `requireSuperAdmin`, not an organization permission. */
export function PlatformAdminLayout() {
  return (
    <div className="flex flex-col gap-5">
      <div>
        <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Platform Admin — Billing</h1>
        <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">
          Plan catalog, coupons, and revenue across every organization on the platform.
        </p>
      </div>

      <div className="-mb-px flex gap-1 overflow-x-auto border-b border-gray-200 dark:border-gray-800">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `flex shrink-0 items-center gap-1.5 border-b-2 px-3 py-2.5 text-sm font-medium transition-colors ${
                isActive
                  ? 'border-brand-600 text-brand-700 dark:border-brand-400 dark:text-brand-300'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200'
              }`
            }
          >
            <tab.icon className="h-4 w-4" />
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
